import {FC, useState} from "react";
import api from "../services/api";
import {Client} from "../context/DataContext";

const CleanupModal: FC<{
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    clients: Client[];
    categories: {id: number, name: string}[];
}> = ({ isOpen, onClose, onSuccess, clients, categories }) => {
    const [selectedClientId, setSelectedClientId] = useState<string>('-1');
    const [selectedCategoryId, setSelectedCategoryId] = useState<string>('-1');
    const [confirmText, setConfirmText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const close = () => {
        setSelectedClientId('-1');
        setSelectedCategoryId('-1')
        setConfirmText('')
        onClose();
    }

    const handleCleanup = async () => {
        setIsLoading(true);
        setError('');
        try {
            const response = await api.post('/api/qrcodes/archiveAndCleanup', null, {
                params: {
                    idClient: selectedClientId,
                    idCategory: selectedCategoryId,
                }
            });
            if (response.data.status) {
                onSuccess();
                close();
            } else {
                throw new Error(response.data.message);
            }
        } catch (err: any) {
            setError(err.message || "Errore durante l'operazione di pulizia.");
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    const isConfirmDisabled = confirmText.toUpperCase() !== 'ARCHIVIA';

    return (
        <div className="fixed inset-0 bg-black/70 z-50 flex justify-center items-center p-4">
            <div className="bg-slate-800 border border-slate-700 rounded-xl w-full max-w-lg shadow-lg">
                <div className="p-6 border-b border-slate-700">
                    <h2 className="text-xl font-bold text-white">Archivia e Pulisci Dati</h2>
                    <p className="text-slate-400 mt-1">Questa operazione archivierà i dati selezionati e li rimuoverà dal database. L'azione è irreversibile.</p>
                </div>
                <div className="p-6 space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-slate-300 mb-2">Filtra per Cliente (opzionale)</label>
                        <select value={selectedClientId} onChange={e => setSelectedClientId(e.target.value)} className="w-full bg-slate-900 border border-slate-600 rounded-lg px-4 py-3 text-white">
                            <option value="-1">Tutti i Clienti</option>
                            {clients.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-slate-300 mb-2">Filtra per Categoria (opzionale)</label>
                        <select value={selectedCategoryId} onChange={e => setSelectedCategoryId(e.target.value)} className="w-full bg-slate-900 border border-slate-600 rounded-lg px-4 py-3 text-white">
                            <option value="-1">Tutte le Categorie</option>
                            {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-slate-300 mb-2">Per confermare, digita "ARCHIVIA"</label>
                        <input type="text" value={confirmText} onChange={e => setConfirmText(e.target.value)} className="w-full bg-slate-900 border border-slate-600 rounded-lg px-4 py-3 text-white uppercase" />
                    </div>
                    {error && <p className="text-red-400 text-sm">{error}</p>}
                </div>
                <div className="p-4 bg-slate-900/50 flex justify-end space-x-4">
                    <button onClick={close} className="px-4 py-2 rounded-lg text-white font-semibold bg-slate-700 hover:bg-slate-600">Annulla</button>
                    <button onClick={handleCleanup} disabled={isConfirmDisabled || isLoading} className="px-4 py-2 rounded-lg text-white font-semibold bg-red-600 hover:bg-red-500 disabled:bg-slate-600 disabled:cursor-not-allowed">
                        {isLoading ? 'In corso...' : 'Archivia e Elimina'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CleanupModal;